export const ALGOLIA_APP_ID = process.env.REACT_APP_ALGOLIA_APP_ID
export const ALGOLIA_APP_KEY = process.env.REACT_APP_ALGOLIA_APP_KEY
export const REACT_APP_INDEX_NAME = process.env.REACT_APP_INDEX_NAME
export const REACT_APP_ALGOLIA_DB = process.env.REACT_APP_ALGOLIA_DB
